import { Pipe, PipeTransform } from '@angular/core';
import * as nationalities from 'i18n-nationality';

@Pipe({ name: 'nationalityDisplayLabel', standalone: true, pure: true })
export class NationalityDisplayLabelPipe implements PipeTransform {
  transform(storedCode: string, lang: string): string {
    if (!storedCode) return storedCode;
    // DB-Format: ISO-3166-1-Alpha-2-Code (z. B. "DE")
    const name = nationalities.getName(storedCode.toUpperCase(), lang);
    if (name) return name.toLowerCase();
    // Legacy-Fallback: Vor-Migrations-Daten enthalten das Adjektiv direkt
    return storedCode.toLowerCase();
  }
}